import React from 'react';
import { Link } from '../../../env';
const Tutorials = ({ handleMain }) => {
    const Tutorials = [
        {
            label: 'Introduction of software and tools',
            downloadLink: `${Link}/assets/Movies/1.Introductionofsoftwareandtools.mp4`,
            img: `${Link}/assets/TutorialsImage/معرفی-ابزارا-everglow.jpg`,
            parspackHost: 'https://c695764.parspack.net/c695764/IRSystem_Software/videoes/Farsi/1-%20%D9%85%D8%B9%D8%B1%D9%81%DB%8C%20%D9%86%D8%B1%D9%85%20%D8%A7%D9%81%D8%B2%D8%A7%D8%B1%20%D9%88%20%D8%A7%D8%A8%D8%B2%D8%A7%D8%B1%D9%87%D8%A7.mp4',
        },
        {
            label: 'Engine Simolator',
            downloadLink: `${Link}/assets/Movies/simolator.mp4`,
            img: `${Link}/assets/TutorialsImage/سیمیلاتور-everglow.jpg`,
            parspackHost: 'http://c695764.parspack.net/c695764/IRSystem_Software/videoes/Farsi/simolator.mp4',
        },
        {
            label: 'Editing and tuning tables',
            downloadLink: `${Link}/assets/Movies/2.Editingandtuningtables.mp4`,
            img: `${Link}/assets/TutorialsImage/ویرایش-و-تیونینگ-everglow.jpg`,
            parspackHost: 'http://c695764.parspack.net/c695764/IRSystem_Software/videoes/Farsi/2%20-%20%D9%88%DB%8C%D8%B1%D8%A7%DB%8C%D8%B4%20%D9%88%20%D8%AA%DB%8C%D9%88%D9%86%DB%8C%D9%86%DA%AF%20%D8%AC%D8%AF%D8%A7%D9%88%D9%84.mp4',

        },
        {
            label: 'Tabulation and introduction of ECU',
            downloadLink: `${Link}/assets/Movies/3.TabulationandintroductionofIsio.mp4`,
            img: `${Link}/assets/TutorialsImage/معرفی-ایسیو-و-ساخت-جداول-شخصی-everglow.jpg`,
            parspackHost: 'http://c695764.parspack.net/c695764/IRSystem_Software/videoes/Farsi/3%20-%20%D8%AC%D8%AF%D9%88%D9%84%20%D8%B3%D8%A7%D8%B2%DB%8C%20%D9%88%20%D9%85%D8%B9%D8%B1%D9%81%DB%8C%20%D8%A7%DB%8C%D8%B3%DB%8C%D9%88.mp4',

        },
        {
            label: 'Comparison of dumps',
            downloadLink: `${Link}/assets/Movies/4.Comparisonofdumps.mp4`,
            img: `${Link}/assets/TutorialsImage/مقاسیه-دامپها-1.bmp`,
            parspackHost: 'http://c695764.parspack.net/c695764/IRSystem_Software/videoes/Farsi/4%20-%20%D9%85%D9%82%D8%A7%DB%8C%D8%B3%D9%87%20%D8%AF%D8%A7%D9%85%D9%BE%D9%87%D8%A7.mp4',

        },
        {
            label: 'Planning',
            downloadLink: `${Link}/assets/Movies/5.Planning.mp4`,
            img: `${Link}/assets/TutorialsImage/برنامه-ریزی-پیشرفته-everglow.jpg`,
            parspackHost: 'http://c695764.parspack.net/c695764/IRSystem_Software/videoes/Farsi/5%20-%20%D8%A8%D8%B1%D9%86%D8%A7%D9%85%D9%87%20%D8%B1%DB%8C%D8%B2%DB%8C.mp4',

        },
        {
            label: 'Hex Editor',
            downloadLink: `${Link}/assets/Movies/6.HexEditor.mp4`,
            img: `${Link}/assets/TutorialsImage/هگز-ادیتور-پیشرفته-everglow-1.jpg`,
            parspackHost: 'http://c695764.parspack.net/c695764/IRSystem_Software/videoes/Farsi/6%20-%20%D9%87%DA%AF%D8%B2%20%D8%A7%D8%AF%DB%8C%D8%AA%D9%88%D8%B1.mp4',

        },
        {
            label: 'Loading Winolse packages',
            downloadLink: `${Link}/assets/Movies/7.LoadingWinolsepackages.mp4`,
            img: `${Link}/assets/TutorialsImage/بارگزاری-پک-های-وین-اولز-1-everglow.jpg`,
            parspackHost: 'http://c695764.parspack.net/c695764/IRSystem_Software/videoes/Farsi/7%20-%20%D8%A8%D8%A7%D8%B1%DA%AF%D8%B2%D8%A7%D8%B1%DB%8C%20%D9%BE%DA%A9%D9%87%D8%A7%DB%8C%20%D9%88%DB%8C%D9%86%20%D8%A7%D9%88%D9%84%D8%B2.mp4',

        },
        {
            label: 'Automatic Ramp',
            downloadLink: `${Link}/assets/Movies/8.AutomaticRamp.mp4`,
            img: `${Link}/assets/TutorialsImage/ریمپ-اتوماتیک-everglow.jpg`,
            parspackHost: 'http://c695764.parspack.net/c695764/IRSystem_Software/videoes/Farsi/8%20-%20%D8%B1%DB%8C%D9%85%D9%BE%20%D8%A7%D8%AA%D9%88%D9%85%D8%A7%D8%AA%DB%8C%DA%A9.mp4',

        },
        {
            label: 'How to use gauge.mp4',
            downloadLink: `${Link}/assets/Movies/9.Howtousegauge.mp4`,
            img: `${Link}/assets/TutorialsImage/gauge.bmp`,
            parspackHost: 'http://c695764.parspack.net/c695764/IRSystem_Software/videoes/Farsi/%D9%86%D8%AD%D9%88%D9%87%20%DA%A9%D8%A7%D8%B1%D8%A8%D8%B1%D8%AF%20%DA%AF%DB%8C%D8%AC.mp4',

        },
        {
            label: 'How to copy and paste on the table',
            downloadLink: `${Link}/assets/Movies/10.Howtocopyandpasteonthetable.mp4`,
            img: `${Link}/assets/TutorialsImage/copypaste.bmp`,
            parspackHost: 'http://c695764.parspack.net/c695764/IRSystem_Software/videoes/Farsi/%D9%86%D8%AD%D9%88%D9%87%20%DA%A9%D9%BE%DB%8C%20%D9%88%20%D9%BE%DB%8C%D8%B3%D8%AA%20%D8%AF%D8%B1%20%D8%B1%D9%88%DB%8C%20%D8%AC%D8%AF%D9%88%D9%84.mp4',

        },
        {
            label: 'Advanced editing of tables',
            downloadLink: `${Link}/assets/Movies/11.Advancededitingoftables.mp4`,
            img: `${Link}/assets/TutorialsImage/ویرایش حرفه ای جداول advance edit-everglow.jpg`,
            parspackHost: 'http://c695764.parspack.net/c695764/IRSystem_Software/videoes/Farsi/%D9%88%DB%8C%D8%B1%D8%A7%DB%8C%D8%B4%20%D9%BE%DB%8C%D8%B4%D8%B1%D9%81%D8%AA%D9%87%20%D8%AC%D8%AF%D8%A7%D9%88%D9%84.mp4',

        },
        {
            label: 'Advanced use of hex editor',
            downloadLink: `${Link}/assets/Movies/12.Advanceduseofhexeditor.mp4`,
            img: `${Link}/assets/TutorialsImage/هگز-ادیتور-پیشرفته-everglow-1.jpg`,
            parspackHost: 'http://c695764.parspack.net/c695764/IRSystem_Software/videoes/Farsi/%DA%A9%D8%A7%D8%B1%D8%A8%D8%B1%D8%AF%20%D9%BE%DB%8C%D8%B4%D8%B1%D9%81%D8%AA%D9%87%20%D9%87%DA%AF%D8%B2%20%D8%A7%D8%AF%DB%8C%D8%AA%D9%88%D8%B1.mp4',

        },
    ]
    return (
        <div className='w-full relative min-h-screen bg-[#283747] overflow-scroll'>
            <div className='w-full sticky top-0 left-0 z-20'>
                <div className='w-full sticky top-0 left-0 z-20 flex justify-end py-3 px-4'>
                    <a href='/'><img src={`${Link}assets/Icons/return.png`} className='w-[50px] rounded-full p-2 border-2 border-white bg-[#1a5276]' onClick={handleMain} /></a>
                </div>
            </div>
            <div className='w-full px-5 absolute top-0 left-0 z-10'>
                {
                    Tutorials.map((item, index) => {
                        return (<>
                            <a key={index} href={item.parspackHost}>
                                <div className='w-full'>
                                    <div className='w-full mt-5 rounded-xl border-2 relative'>
                                        <div className='w-full h-full'>
                                            <img src={item.img} className='w-full rounded-xl h-full bg-cover' />
                                        </div>
                                        <div className='w-full h-full flex justify-start items-end absolute top-0 z-40 bg-[rgba(0,0,0,0.2)]'>
                                            <a href={item.parspackHost}>
                                                <img src={`${Link}/assets/Icons/player.png`} className='w-[45px] m-1' />
                                            </a>
                                        </div>
                                    </div>
                                    <div className='w-full py-3'>
                                        <span className='text-white poppins-medium text-base'>
                                            {item.label}
                                        </span>
                                    </div>
                                    <hr />
                                </div>
                            </a>
                        </>)
                    })
                }
            </div>
        </div>
    );
}

export default Tutorials;
